export const filterInitialState = {
  id: '',
  eventId: '',
  statusCodes: [],

  dateType: 'created',
  dateFrom: null,
  dateTo: null,

  saleType: undefined,
  paymentType: undefined,
  creationType: undefined,

  trade: false,
  ropCheck: false,
  ropCheckFalse: false,

  vin: undefined,
  marka: undefined,
  model: undefined,

  phoneNumber: undefined,
  firstName: undefined,
  lastName: undefined,
  iin: undefined,
  seoIdIsNull: undefined
}

export const paginationInitialState = {
  limit: 10,
  offset: 0,
  count: 0
}
